import { render, staticRenderFns } from "./EmploymentsReport.vue?vue&type=template&id=988e08c2"
import script from "./EmploymentsReport.vue?vue&type=script&lang=js"
export * from "./EmploymentsReport.vue?vue&type=script&lang=js"
import style0 from "./EmploymentsReport.vue?vue&type=style&index=0&id=988e08c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports